<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import ReviewsTooltipContent from "@apps/reviews/components/ReviewsTooltip/ReviewsTooltipContent.svelte";
    import { REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE } from "@apps/reviews/constants";
    import ReviewsListInfoEntity from "@apps/reviews/entities/ReviewsListInfoEntity";
    import { GwI18n } from "@modules/i18n/GwI18n/GwI18n";
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    import AverageReviewsHeader from "./AverageReviewsHeader.svelte";

    export let status: STATUS;
    export let reviewsCount: number;
    export let averageReviewsRating: number;
    export let ratesInfo: ReviewsListInfoEntity["ratesInfo"] = [];
    export let widgetDisplayStyle: REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE;
    // todo remove undefined after schema fix
    export let showStarsDistributionOnHover: boolean | undefined = true;
    export let gwI18n: GwI18n;

    const dispatch = createEventDispatcher();

    const handleGoToReviews = () => {
        dispatch("goToReviews");
    };

    const basedOnReviewsText$ = gwI18n.selectT(
        "reviews.AverageReviewsWidget",
        "based_on_reviews",
        { count: reviewsCount }
    );
    const seeAllReviewsText$ = gwI18n.selectT(
        "reviews.AverageReviewsWidget",
        "see_all_reviews"
    );
</script>

{#if (status === STATUS.READY && reviewsCount === 0) || !showStarsDistributionOnHover}
    <BaseButton
        variant="link"
        size="large"
        ariaLabel="Write a review"
        class="gw-rv-average__btn"
        on:click={handleGoToReviews}
    >
        <AverageReviewsHeader
            {reviewsCount}
            {averageReviewsRating}
            displayStyle={widgetDisplayStyle}
            {gwI18n}
        />
    </BaseButton>
{:else}
    <ReviewsTooltipContent
        allReviewsCount={reviewsCount}
        {averageReviewsRating}
        {ratesInfo}
        basedOnReviewsText={$basedOnReviewsText$}
        seeAllReviewsText={$seeAllReviewsText$}
        showSeeAllReviewsButton
        on:goToReviews={handleGoToReviews}
    >
        <AverageReviewsHeader
            {reviewsCount}
            {averageReviewsRating}
            displayStyle={widgetDisplayStyle}
            {gwI18n}
        />
    </ReviewsTooltipContent>
{/if}

<style>
    :global(.gw-btn.gw-rv-average__btn) {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        color: inherit;
        font-weight: inherit;
        font-family: inherit;
        font-size: inherit;
        text-indent: 0;
        flex-wrap: wrap;
    }
</style>
